module.exports = __webpack_public_path__ + "static/media/icon07.44ec5650.svg";